<div class="ui-g-12 no-padding">
	<div class="ui-g-12 no-horizontal-padding wizard-content-title">
	</div>
	<ng-template
		[ngIf]="context.source.wizardStepLoading"
		[ngIfElse]="Content">
		<div class="ui-g-12 no-horizontal-padding text-center">
			<i class="loading-spinner theme-color fa fa-fw fa-spin fa-spinner">
			</i>
		</div>
	</ng-template>

	<ng-template #Content>
		<ng-template
			[ngIf]="clientMessage !== ''"
			[ngIfElse]="MakePayment">
			<div class="ui-g-12 no-horizontal-padding text-center">
				<span class="panel-sub-title">
					{{clientMessage}}
				</span>
			</div>
		</ng-template>

		<ng-template #MakePayment>
			<div class="ui-g-12 content-section">
				<div class="ui-g-12 no-padding">
					<app-common-dashboard
						[entityContext]="context"
						dashboardDisplayComponentInstanceName = "PolicyTermPaymentScheduleDashboard">
					</app-common-dashboard>
				</div>

				<div class="ui-g-6 no-padding"
					[ngClass]="{
						'ui-g-12': siteLayoutService.displayTabletView,
						'no-padding': siteLayoutService.displayTabletView
					}">
					<app-next-payment-installment-details
						[context]="context">
					</app-next-payment-installment-details>
				</div>

				<div class="ui-g-6 no-padding"
					[ngClass]="{'ui-g-12': siteLayoutService.displayTabletView,
						'no-padding': siteLayoutService.displayTabletView}">
					<app-dynamic-formly
						[dataSet]="context.source.activeMenuItem.currentData"
						[layoutSchema]="dynamicFormlyLayout"
						[context]="context"
						(validityChanged)="validityChanged($event)">
					</app-dynamic-formly>
				</div>
			</div>
		</ng-template>
	</ng-template>
</div>